import { createMachine } from 'xstate';

import shared from 'common/bento/shared';
import { BentoModuleDoneStatus } from 'common/bento/types/BentoModule';
import { AnyMachineEvent } from 'features/Bento/types/Abstract';
import locales from 'features/Onboarding/locales';

import actions, { Action } from './actions';
import guards, { Guard } from './guards';
import model, { Context } from './model';
import services, { Service } from './services';
import { State } from './state';

const machine = createMachine<Context, AnyMachineEvent>(
  {
    context: model.initialContext,

    id: 'research-experiment',

    initial: State.RESEARCH_EXPERIMENT_EVALUATION,

    on: {
      '*': {
        actions: shared.actions.unhandled(),
      },
    },

    states: {
      [State.RESEARCH_EXPERIMENT_EVALUATION]: {
        invoke: {
          onDone: [
            {
              cond: Guard.ShouldShowResearchExperiment,
              target: State.RESEARCH_EXPERIMENT,
            },

            {
              target: State.DONE,
            },
          ],
          onError: {
            actions: Action.LogError,
            target: State.DONE,
          },
          src: Service.EvaluateResearchExperimentEligibility,
        },
      },

      [State.RESEARCH_EXPERIMENT]: {
        entry: shared.actions.trackView(),

        on: {
          ACCEPT_RESEARCH_EXPERIMENT: {
            actions: shared.actions.serverTrack({
              event: 'Onboarding Journey Research Accepted',
            }),
            target: State.RESEARCH_ACCEPTED,
          },

          DECLINE_RESEARCH_EXPERIMENT: [
            {
              actions: [
                Action.SaveResearchExperimentSeen,
                shared.actions.serverTrack({
                  event: 'Onboarding Journey Research Declined',
                }),
              ],
              target: State.DONE,
            },
          ],

          PREV: {
            actions: shared.actions.toast({
              status: 'error',
              title: locales.toast.definitiveStep,
            }),
          },
        },
      },

      [State.RESEARCH_ACCEPTED]: {
        entry: shared.actions.trackView(),

        on: {
          CANCEL_RESEARCH_EXPERIMENT: [
            {
              actions: [
                Action.SaveResearchExperimentSeen,
                shared.actions.serverTrack({
                  event: 'Onboarding Journey Research Cancelled',
                }),
              ],
              target: State.DONE,
            },
          ],

          PREV: State.ABORT_TO_RESET_PROMPT,
        },
      },

      [State.ABORT_TO_RESET_PROMPT]: {
        data: {
          status: BentoModuleDoneStatus.ABORT,
        },
        type: 'final',
      },

      [State.ABORT]: {
        data: {
          status: BentoModuleDoneStatus.ABORT,
        },
        type: 'final',
      },

      [State.DONE]: {
        data: {
          status: BentoModuleDoneStatus.DONE,
        },
        type: 'final',
      },
    },
  },
  {
    actions,
    guards,
    services,
  },
);

export default machine;
